export const features = [
  {
    icon: "ri-shield-check-line",
    title: "稳定流畅不卡顿",
    description: "采用多重CDN加速与智能线路调度，全网节点覆盖，保障高清视频流畅播放，告别缓冲等待。",
  },
  {
    icon: "ri-hd-line",
    title: "真高清画质体验",
    description: "全站支持1080P蓝光画质，多码率自适应切换，无论大屏小屏都能享受影院级观影效果。",
  },
  {
    icon: "ri-tv-2-line",
    title: "海量片源每日更新",
    description: "聚合全网热门电影、电视剧、综艺、动漫资源，每日同步更新，追剧不等待。",
  },
  {
    icon: "ri-device-line",
    title: "全终端无缝适配",
    description: "电脑、平板、手机多端同步，一次搜索即可跨设备续播，随时随地想看就看。",
  },
  {
    icon: "ri-lock-line",
    title: "绿色安全无广告",
    description: "严格审核所有播放源，无弹窗骚扰、无恶意跳转，纯净观影环境守护你的每一次点击。",
  },
];

export const cards = [
  {
    title: "《孤注一掷》全网热播",
    tag: "犯罪悬疑",
    description: "张艺兴、金晨领衔主演，揭露跨国网络诈骗内幕，扣人心弦的高智商博弈，全网话题讨论量突破50亿。",
    image: "https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20movie%20poster%20style%20image%20featuring%20intense%20crime%20thriller%20atmosphere%2C%20dark%20urban%20night%20scene%20with%20neon%20lights%2C%20mysterious%20silhouettes%2C%20cinematic%20color%20grading%20with%20warm%20golden%20highlights%20against%20deep%20shadows%2C%20film%20grain%20texture%2C%20professional%20movie%20promotional%20style%2C%20clean%20background&width=800&height=450&seq=card-movie-01&orientation=landscape",
  },
  {
    title: "《庆余年第二季》重磅回归",
    tag: "古装权谋",
    description: "张若昀再度演绎范闲传奇，原班人马倾力打造，权谋升级、阵容更强，预约人数已突破1500万。",
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20cinematic%20poster%2C%20elegant%20hanfu%20robes%20in%20rich%20crimson%20and%20gold%2C%20traditional%20palace%20architecture%20background%2C%20dramatic%20lighting%20with%20warm%20candlelight%20aesthetic%2C%20epic%20historical%20atmosphere%2C%20film%20promotional%20style%2C%20clean%20composition&width=800&height=450&seq=card-movie-02&orientation=landscape",
  },
  {
    title: "《繁花》沪上风云再起",
    tag: "年代剧情",
    description: "王家卫首部剧集作品，胡歌、马伊琍领衔，上海九十年代商海沉浮，质感绝美引发全网热议。",
    image: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20nostalgic%20cinematic%20scene%2C%20retro%20city%20streets%20with%20vintage%20cars%20and%20neon%20signs%2C%20warm%20golden%20evening%20light%2C%20elegant%20period%20drama%20aesthetic%2C%20film%20grain%20texture%2C%20Wong%20Kar%20Wai%20style%20color%20palette%2C%20cinematic%20composition%2C%20clean%20background&width=800&height=450&seq=card-movie-03&orientation=landscape",
  },
  {
    title: "《流浪地球3》前瞻特辑",
    tag: "科幻巨制",
    description: "郭帆导演科幻系列第三部，前作全球票房超87亿，国产科幻天花板再度突破想象力边界。",
    image: "https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20cinematic%20scene%20with%20massive%20spaceship%20and%20distant%20planet%2C%20deep%20space%20background%20with%20stars%2C%20dramatic%20blue%20and%20orange%20lighting%20contrast%2C%20futuristic%20technology%2C%20cinematic%20widescreen%20composition%2C%20clean%20promotional%20style&width=800&height=450&seq=card-movie-04&orientation=landscape",
  },
  {
    title: "《与凤行》仙侠天花板",
    tag: "仙侠玄幻",
    description: "赵丽颖监制并主演，唯美东方仙侠世界，特效制作精良，开播即引爆热搜话题。",
    image: "https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20drama%20scene%2C%20floating%20celestial%20palaces%20among%20clouds%2C%20flowing%20silk%20robes%20in%20pastel%20pink%20and%20white%2C%20magical%20particles%20and%20soft%20glowing%20light%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20clean%20background&width=800&height=450&seq=card-movie-05&orientation=landscape",
  },
  {
    title: "《三体》剧版深度解析",
    tag: "硬核科幻",
    description: "刘慈欣雨果奖原作改编，国产科幻剧集的里程碑之作，每一帧都是对原著的深情致敬。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20scene%20with%20three%20suns%20in%20alien%20sky%2C%20ancient%20astronomical%20instruments%2C%20dark%20and%20contemplative%20atmosphere%2C%20cinematic%20sci-fi%20aesthetic%2C%20deep%20space%20mystery%2C%20clean%20composition%2C%20professional%20promotional%20style&width=800&height=450&seq=card-movie-06&orientation=landscape",
  },
  {
    title: "《周处除三害》口碑炸裂",
    tag: "动作犯罪",
    description: "阮经天演技封神之作，台湾黑帮动作片新标杆，豆瓣评分8.1，年度必看华语电影。",
    image: "https://readdy.ai/api/search-image?query=Gritty%20action%20crime%20thriller%20cinematic%20scene%2C%20dark%20alley%20with%20dramatic%20shadows%2C%20intense%20urban%20night%20atmosphere%2C%20Taiwanese%20street%20aesthetic%2C%20cinematic%20color%20grading%20with%20cool%20tones%2C%20film%20grain%2C%20clean%20composition&width=800&height=450&seq=card-movie-07&orientation=landscape",
  },
];

export const indexItems = [
  {
    title: "2024暑期档必看合集",
    description: "院线大片 + 热播剧集一网打尽",
    count: 48,
    icon: "ri-sun-line",
  },
  {
    title: "豆瓣评分8.5+精选",
    description: "严选高分好片，拒绝烂片踩雷",
    count: 126,
    icon: "ri-star-line",
  },
  {
    title: "国产悬疑剧天花板",
    description: "烧脑反转，全程高能不断",
    count: 35,
    icon: "ri-search-eye-line",
  },
  {
    title: "经典港片修复版",
    description: "4K画质重温黄金年代",
    count: 89,
    icon: "ri-film-line",
  },
  {
    title: "韩剧热播TOP20",
    description: "高分韩剧实时更新，追剧神器",
    count: 20,
    icon: "ri-heart-pulse-line",
  },
  {
    title: "国漫崛起必看清单",
    description: "从大圣到哪吒，见证国漫蜕变",
    count: 42,
    icon: "ri-rocket-line",
  },
  {
    title: "深夜惊悚恐怖片单",
    description: "胆小慎入，肾上腺素飙升体验",
    count: 23,
    icon: "ri-ghost-line",
  },
];

export const mediaItems = [
  {
    title: "《封神第二部》独家前瞻",
    duration: "03:25",
    description: "乌尔善导演神话史诗续作，闻仲、魔家四将悉数登场，特效全面升级，2025春节档最受期待。",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20cinematic%20scene%2C%20ancient%20Chinese%20warriors%20in%20elaborate%20armor%2C%20majestic%20palace%20and%20mountain%20landscape%2C%20dramatic%20golden%20and%20crimson%20lighting%2C%20epic%20battle%20atmosphere%2C%20cinematic%20widescreen%2C%20clean%20composition&width=800&height=450&seq=media-01&orientation=landscape",
  },
  {
    title: "《唐朝诡事录之西行》探案集",
    duration: "05:12",
    description: "杨旭文、杨志刚再续前缘，大唐奇案悬疑升级，西域风情与中式志怪完美融合。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20Tang%20Dynasty%20Chinese%20period%20detective%20drama%20scene%2C%20ancient%20Chinese%20architecture%20with%20lanterns%2C%20foggy%20night%20atmosphere%2C%20traditional%20costumes%2C%20mysterious%20and%20elegant%20aesthetic%2C%20cinematic%20composition%2C%20clean%20background&width=800&height=450&seq=media-02&orientation=landscape",
  },
  {
    title: "《大江大河3》时代终章",
    duration: "04:48",
    description: "王凯、杨烁、董子健再度聚首，改革开放浪潮中的个人命运，一代人的奋斗史诗终迎结局。",
    image: "https://readdy.ai/api/search-image?query=1980s%20China%20reform%20era%20cinematic%20scene%2C%20industrial%20factories%20and%20urban%20development%2C%20warm%20nostalgic%20lighting%2C%20period%20drama%20aesthetic%2C%20hopeful%20and%20determined%20atmosphere%2C%20cinematic%20widescreen%2C%20clean%20composition&width=800&height=450&seq=media-03&orientation=landscape",
  },
];

export const appItem = {
  title: "丁香花影院 · 移动端",
  description: "扫码或在应用商店搜索「丁香花影院」，随时随地追剧观影。移动端专属悬浮窗播放、夜间模式、离线缓存功能，让好剧不再受场景限制。",
  features: ["悬浮窗播放", "夜间护眼模式", "智能推荐引擎", "跨设备续播"],
  qrImage: "https://readdy.ai/api/search-image?query=A%20minimalist%20modern%20QR%20code%20design%20on%20clean%20white%20background%2C%20surrounded%20by%20subtle%20geometric%20decorative%20elements%20in%20warm%20golden%20tones%2C%20clean%20and%20professional%20layout%2C%20no%20text&width=400&height=400&seq=app-qr-01&orientation=squarish",
};

export const faqItems = [
  {
    question: "丁香花影院需要注册才能观看吗？",
    answer: "完全不需要。丁香花影院始终坚持免费开放，所有电影、电视剧均可直接搜索观看，无需注册、无需登录、无需付费，打开即看。",
  },
  {
    question: "为什么有的影片播放时有轻微缓冲？",
    answer: "缓冲通常与您的网络环境有关。丁香花影院采用多线路智能调度，您可以在播放器右下角手动切换播放线路，选择当前网络下最优的源。建议使用WiFi或5G网络获得最佳体验。",
  },
  {
    question: "影片的画质可以达到什么水平？",
    answer: "主流影片均提供1080P蓝光画质选项，部分热门大片支持4K分辨率。播放器会根据您的网络带宽自动匹配最佳码率，也可在播放器设置中手动选择固定画质。",
  },
  {
    question: "新上映的电影什么时候能上线？",
    answer: "热播影片通常在院线下映后1-3个月内上线。热播电视剧一般在播出平台更新后24小时内同步上线。关注本站「最新动态」板块，第一时间获取上新通知。",
  },
  {
    question: "如果遇到无法播放的情况怎么办？",
    answer: "如遇播放异常，请依次尝试：1) 切换播放线路（播放器右下角）；2) 刷新页面；3) 清除浏览器缓存。若仍无法解决，可通过「联系我们」反馈，我们的技术团队会在24小时内处理。",
  },
];

export const aboutData = {
  title: "关于丁香花影院",
  paragraphs: [
    "丁香花影院成立于2021年，是国内领先的免费在线影视平台之一。我们致力于为影迷提供高清、流畅、无广告的观影体验，让每个人都能轻松享受电影和电视剧的魅力。",
    "平台汇聚了超过5万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。每日同步更新国内外最新影片，确保追剧用户不错过任何精彩。",
    "技术团队深耕视频播放领域多年，自研多重CDN加速和智能调度系统，保障全网用户流畅观影。我们始终坚持以用户体验为核心，持续优化产品功能和内容质量。",
    "丁香花影院，让你的每一次观影都是一次享受。",
  ],
};

export const contactData = {
  title: "联系我们",
  description: "如有影片推荐、资源反馈或商务合作需求，欢迎通过以下方式与我们取得联系。我们珍视每一位用户的建议，共同打造更好的追剧平台。",
  email: "feedback@dingxianghua.cn",
  wechat: "dingxianghua_vip",
  qq: "10001",
};

export const topics = [
  { name: "暑期档票房预测", heat: "9.8万讨论", tag: "热" },
  { name: "朱一龙新片定档", heat: "7.2万讨论", tag: "新" },
  { name: "国产悬疑剧天花板", heat: "6.5万讨论", tag: "热" },
  { name: "NETFLIX韩剧推荐", heat: "5.8万讨论", tag: "" },
  { name: "古装剧服化道对比", heat: "5.1万讨论", tag: "" },
  { name: "暑期亲子观影指南", heat: "4.6万讨论", tag: "荐" },
  { name: "IMAX vs 杜比影院", heat: "3.9万讨论", tag: "" },
  { name: "王一博新剧路透", heat: "3.2万讨论", tag: "新" },
  { name: "经典老片修复计划", heat: "2.8万讨论", tag: "" },
  { name: "国产科幻电影未来", heat: "2.1万讨论", tag: "" },
  { name: "豆瓣评分争议榜", heat: "1.7万讨论", tag: "" },
];

export const updates = [
  {
    date: "2026-07-31",
    title: "《默杀》高清修复版上线",
    description: "柯汶利导演最新作品，犯罪悬疑题材，张钧甯、黄健玮主演，全网独家蓝光画质。",
    tag: "新上线",
  },
  {
    date: "2026-07-30",
    title: "《唐朝诡事录之西行》全集更新完毕",
    description: "36集全已上线，大唐奇案系列完结，豆瓣评分8.7创系列新高。",
    tag: "完结",
  },
  {
    date: "2026-07-29",
    title: "暑期档特别专题「港片黄金年代」上线",
    description: "精选80-90年代经典港片修复版，周星驰、成龙、周润发代表作一次看够。",
    tag: "专题",
  },
  {
    date: "2026-07-27",
    title: "播放器性能全面优化升级",
    description: "新版播放器加载速度提升40%，新增画中画模式与手势控制，移动端体验大幅改善。",
    tag: "升级",
  },
  {
    date: "2026-07-25",
    title: "《大江大河3》超前点播开启",
    description: "大结局提前解锁，王凯、杨烁、董子健时代三部曲完美收官。",
    tag: "热播",
  },
  {
    date: "2026-07-22",
    title: "新增多国语言字幕支持",
    description: "热门影片现已支持中、英、日、韩四语字幕切换，满足不同用户需求。",
    tag: "功能",
  },
  {
    date: "2026-07-20",
    title: "《周处除三害》导演剪辑版首发",
    description: "比院线版多出15分钟未曝光片段，阮经天封神演技完整呈现。",
    tag: "独家",
  },
];

export const rankingItems = [
  {
    rank: 1,
    title: "庆余年 第二季",
    type: "电视剧",
    hot: "1.2亿热度",
    tag: "↑3",
    tagUp: true,
  },
  {
    rank: 2,
    title: "孤注一掷",
    type: "电影",
    hot: "9800万热度",
    tag: "↑1",
    tagUp: true,
  },
  {
    rank: 3,
    title: "封神第一部",
    type: "电影",
    hot: "8600万热度",
    tag: "新",
    tagUp: true,
  },
  {
    rank: 4,
    title: "与凤行",
    type: "电视剧",
    hot: "7200万热度",
    tag: "↓2",
    tagUp: false,
  },
  {
    rank: 5,
    title: "唐朝诡事录之西行",
    type: "电视剧",
    hot: "6500万热度",
    tag: "↑4",
    tagUp: true,
  },
  {
    rank: 6,
    title: "繁花",
    type: "电视剧",
    hot: "5800万热度",
    tag: "↓1",
    tagUp: false,
  },
];

export const carouselItems = [
  {
    title: "暑期档最强片单：10部必看大片",
    description: "从科幻巨制到悬疑烧脑，从温情喜剧到热血动作，精选本季最值得期待的十部院线及流媒体新片。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20summer%20blockbuster%20movie%20collage%20atmosphere%2C%20diverse%20film%20genres%20from%20sci-fi%20to%20drama%2C%20vibrant%20warm%20summer%20lighting%2C%20epic%20scale%2C%20professional%20cinematic%20style%20with%20rich%20golden%20and%20coral%20accents%2C%20clean%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape",
    tag: "暑期特辑",
  },
  {
    title: "国剧出海：世界正在追哪些中国剧",
    description: "从《甄嬛传》到《狂飙》，中国电视剧在全球范围内的影响力持续攀升，盘点海外最受欢迎的十部国剧。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20drama%20global%20popularity%20concept%2C%20world%20map%20with%20Chinese%20cultural%20elements%2C%20traditional%20and%20modern%20fusion%2C%20warm%20golden%20and%20red%20color%20palette%2C%20elegant%20cinematic%20style%2C%20clean%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape",
    tag: "深度策划",
  },
  {
    title: "悬疑剧迷必藏：高能反转TOP20",
    description: "精心整理近十年口碑最好的华语悬疑剧集，从《白夜追凶》到《漫长的季节》，每一部都值得反复品味。",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20cinematic%20atmosphere%2C%20dark%20rainy%20city%20streets%20with%20dramatic%20shadows%2C%20film%20noir%20aesthetic%2C%20investigation%20theme%2C%20moody%20lighting%20with%20deep%20contrast%2C%20cinematic%20composition%2C%20clean%20background&width=1200&height=600&seq=carousel-03&orientation=landscape",
    tag: "编辑精选",
  },
  {
    title: "动漫迷集结：2024年度霸权争夺",
    description: "国漫与日漫的年度最强对决，从《完美世界》到《鬼灭之刃》，谁才是今年的真正霸权？",
    image: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20style%20cinematic%20scene%2C%20vibrant%20action%20composition%20with%20dramatic%20lighting%2C%20epic%20battle%20atmosphere%2C%20rich%20warm%20and%20cool%20color%20contrast%2C%20professional%20animation%20promotional%20style%2C%20clean%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape",
    tag: "年度企划",
  },
  {
    title: "导演特辑：王家卫的光影世界",
    description: "从《重庆森林》到《繁花》，梳理墨镜王三十年的影像美学，一窥华语电影最具辨识度的视觉风格。",
    image: "https://readdy.ai/api/search-image?query=Wong%20Kar%20Wai%20style%20cinematic%20scene%2C%20nostalgic%20Hong%20Kong%20night%20streets%20with%20neon%20signs%2C%20intimate%20atmosphere%2C%20rich%20saturated%20colors%20of%20red%20and%20green%2C%20film%20grain%20texture%2C%20artistic%20composition%2C%20clean%20background&width=1200&height=600&seq=carousel-05&orientation=landscape",
    tag: "导演特辑",
  },
  {
    title: "豆瓣9分神剧：一生必看的华语经典",
    description: "那些在豆瓣上获得9分以上的现象级华语剧集，从《大明王朝1566》到《觉醒年代》，不朽经典一网打尽。",
    image: "https://readdy.ai/api/search-image?query=Timeless%20classic%20Chinese%20historical%20drama%20atmosphere%2C%20ancient%20Chinese%20study%20room%20with%20scrolls%20and%20calligraphy%2C%20warm%20golden%20candlelight%2C%20scholarly%20elegance%2C%20rich%20cultural%20heritage%20aesthetic%2C%20cinematic%20composition%2C%20clean%20background&width=1200&height=600&seq=carousel-06&orientation=landscape",
    tag: "经典回顾",
  },
];

export const comments = [
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20woman%2C%20warm%20natural%20lighting%2C%20soft%20background%2C%20friendly%20expression%2C%20clean%20headshot%20style&width=120&height=120&seq=avatar-01&orientation=squarish",
    name: "追剧达人小陈",
    date: "2026-07-28",
    content: "用了丁香花影院一年多，真心推荐！片源更新速度超快，画质也很清晰。最重要的是没有那些烦人的弹窗广告，观影体验比很多收费平台都好。",
    source: "《庆余年第二季》评论区",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20middle%20aged%20Chinese%20man%2C%20warm%20natural%20lighting%2C%20soft%20background%2C%20friendly%20expression%2C%20clean%20headshot%20style&width=120&height=120&seq=avatar-02&orientation=squarish",
    name: "老电影收藏家",
    date: "2026-07-25",
    content: "惊喜发现这里有很多经典老片的高清修复版！周星驰全集、成龙经典都找到了，画质修复得很棒，这才是真正的影迷福利。",
    source: "「港片黄金年代」专题评论区",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20Chinese%20woman%20with%20glasses%2C%20warm%20natural%20lighting%2C%20soft%20background%2C%20friendly%20expression%2C%20clean%20headshot%20style&width=120&height=120&seq=avatar-03&orientation=squarish",
    name: "悬疑剧十级学者",
    date: "2026-07-22",
    content: "悬疑剧合集太赞了！从《白夜追凶》到《漫长的季节》再到《唐朝诡事录》，一路追下来太过瘾。专题整理得很有条理，找剧超方便。",
    source: "「国产悬疑剧天花板」专题评论区",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20warm%20natural%20lighting%2C%20soft%20background%2C%20friendly%20expression%2C%20clean%20headshot%20style&width=120&height=120&seq=avatar-04&orientation=squarish",
    name: "周末影咖小刘",
    date: "2026-07-18",
    content: "每周五晚固定来丁香花影院找片，片库真的全，冷门文艺片也能找到。多线路切换功能很实用，公司网不好换个线路就流畅了。",
    source: "《繁花》评论区",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20Chinese%20woman%20in%20her%2030s%2C%20warm%20natural%20lighting%2C%20soft%20background%2C%20friendly%20expression%2C%20clean%20headshot%20style&width=120&height=120&seq=avatar-05&orientation=squarish",
    name: "带娃妈妈看剧党",
    date: "2026-07-15",
    content: "有了孩子之后去电影院的机会少了，丁香花影院成了我的精神粮仓。夜间模式很贴心，晚上追剧不刺眼，推荐给所有宝妈！",
    source: "《与凤行》评论区",
  },
];

export const navItems = [
  { label: "首页", href: "#hero" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
  { label: "专题合集", href: "#index" },
  { label: "精彩预告", href: "#media" },
  { label: "热门推荐", href: "#cards" },
];